import type { IPaginationSettings } from '@/api/types';
import type { EEducationLevel, EStudyForm, EStudyYear } from '@/shared/types';

/**
 * Статусы заявки
 */
export enum EApplicationStatus {
  Approved = 'approved',
  Rejected = 'rejected',
  OnChecking = 'on_checking',
}

export interface IAdmissionApplication {
  id: number;
  status: EApplicationStatus;
  user: {
    full_name: string;
    email: string;
    phone: string;
  };
  rejection_reason: string;
  created_at: string;
}

export interface IAdmissionApplicationsStats {
  total: number;
  approved: number;
  rejected: number;
  on_checking: number;
}

export interface IAdmissionApplicationsResponse {
  data: IAdmissionApplication[];
  meta: {
    pagination: IPaginationSettings;
    stats: IAdmissionApplicationsStats;
  };
}

export interface ICurrentAdmissionApplication {
  id: number;
  status: EApplicationStatus;
  created_at: string;
  specialization: string;
  education_level: EEducationLevel;
  study_form: EStudyForm;
  study_year: EStudyYear;
  motivation: string;
  available_time: string;
  has_computer: boolean;
  currently_working: boolean;
  work_place?: string;
  city: string;
  university: string;
  user: {
    full_name: string;
    email: string;
    phone?: string;
  };
}

export interface IAdmissionApplicationResponse {
  data: ICurrentAdmissionApplication;
}

export interface ISendNotificationsResponse {
  data: {
    count: number;
    notifications_sent_at: string;
  };
}

export interface IMoveToNextStageResponse {
  data: {
    total_count: number;
    succeeded_count: number;
    failed_count: number;
    failed: { id: number; email: string }[];
  };
}
